module.exports = __webpack_public_path__ + "img/shipo-icon-order-top-disable.8caa88fb.svg";